
/**
 * Enhanced hook that ensures backward compatibility
 * while migrating to the context-based system
 */
import { useVezgoNavigation as useVezgoNavigationFromContext } from '../context/navigation';
import { logger } from '@/services/LoggingService';

/**
 * Enhanced hook that ensures backward compatibility
 * while migrating to the context-based system
 */
export function useVezgoNavigation() {
  // Just use the context directly now that we've migrated everything
  const navigationContext = useVezgoNavigationFromContext();
  
  logger.debug('useVezgoNavigation', 'Using navigation context directly');
  
  return navigationContext;
}
